import React, {useMemo} from 'react';
import { useForm } from 'react-hook-form';
import { BtnComponent } from '../../components/button';
import { PageDialogContent, PageDialogFooter } from '../../components/dialog';
import { InputField } from '../../components/reactHookFormFields/inputField';
import { toast } from 'react-toastify';
import { useGroupChatContext } from '../../context/groupchatContext';
import { ChangePin } from '../../services/login';

const ChangePincode = ({closeChangePinCodePopup}) => {

    const { control, formState: { errors }, handleSubmit, } = useForm();
    const groupChatContext = useGroupChatContext();
    const {authData,isShowPinCreateScreenOnFirstLogin,setIsShowPinCreateScreenOnFirstLogin} = useMemo(() => ({
        authData: groupChatContext.authData,
        isShowPinCreateScreenOnFirstLogin: groupChatContext.isShowPinCreateScreenOnFirstLogin,
        setIsShowPinCreateScreenOnFirstLogin: groupChatContext.setIsShowPinCreateScreenOnFirstLogin,

    }));
    
    const onSubmitForm = async(data, e) => {
        e.preventDefault();

        if(data.new_pin == data.confirm_pin){
            let token = '&na_auth='+ authData.auth;
            const postData = {
                pincode: data.new_pin,
                // current_password: data.current_password
            }
            ChangePin(postData, token).then((res) => {

                if(res?.data?.response.code == 0){
                    toast.success(res?.data?.response?.msg);
                    authData.pincode = data.new_pin;
                    localStorage.setItem('createPinOnFirstLogin', false);
                    setIsShowPinCreateScreenOnFirstLogin(false);
                    closeChangePinCodePopup();
                }
                else {
                    toast.error(res?.data?.response?.msg);
                }
            });
        }else{
            toast.error("New pin and confirm pin must be same.")
        }
    }

    return (
        <>
            <PageDialogContent
                contentCls="pt-4 pb-2 px-4 sm:px-6 overflow-y-auto"
                hideOverFlow={true}
                contentScroll={false}
            >
                <form id="save_change_pincode_form" onSubmit={handleSubmit(onSubmitForm)} className="max-w-xl">
                    <p className="text-sm text-gray-600 text-center mb-4 sm:mb-5">
                        Please set a 4-digit pincode. You’ll use it to quickly access the app.
                    </p>

                    <div className="w-full flex flex-col sm:flex-row sm:gap-4 gap-4 sm:gap-5 text-gray-600">
                        <div className="flex-1 min-w-0">
                            <InputField
                                title="New Pincode"
                                name="new_pin"
                                control={control}
                                rules={{
                                    required: { value: true, message: "New pincode is required" },
                                    pattern: { value: /^[0-9]{4}$/, message: "Pincode must be exactly 4 digits" },
                                }}
                                onInput={(e) => {
                                    e.target.value = e.target.value.replace(/[^0-9]/g, "").slice(0, 4);
                                }}
                                inputMode="numeric"
                                maxLength={4}
                                errors={errors}
                            />
                        </div>
                        <div className="flex-1 min-w-0">
                            <InputField
                                title="Confirm Pincode"
                                name="confirm_pin"
                                control={control}
                                rules={{
                                    required: { value: true, message: "Confirm pincode is required" },
                                    pattern: { value: /^[0-9]{4}$/, message: "Pincode must be exactly 4 digits" },
                                }}
                                onInput={(e) => {
                                    e.target.value = e.target.value.replace(/[^0-9]/g, "").slice(0, 4);
                                }}
                                inputMode="numeric"
                                maxLength={4}
                                errors={errors}
                            />
                        </div>
                    </div>
                </form>
            </PageDialogContent>
            <PageDialogFooter>
                <div className="flex flex-wrap items-center gap-2 w-full sm:w-auto">
                    {!isShowPinCreateScreenOnFirstLogin && (
                        <BtnComponent text="Close" btnType="default" onClick={closeChangePinCodePopup} />
                    )}
                    <BtnComponent text="Save" btnType="primary_theme" form="save_change_pincode_form" type="submit" />
                </div>
            </PageDialogFooter>
        </>
    );
};

export default ChangePincode;
